import { Alert } from "@mui/material";
import Snackbar, { SnackbarCloseReason } from "@mui/material/Snackbar";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideToast } from "../../store/toastSlice";

function SnackbarPopup() {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();

  const { isOpen, message, type, duration } = useSelector(
    (toast: any) => toast.toast
  );

  React.useEffect(() => {
    setOpen(isOpen);
    setTimeout(() => {
      dispatch(hideToast());
    }, duration);
  }, [isOpen, duration, dispatch]);

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  return (
    <div>
      <Snackbar
        open={open}
        autoHideDuration={duration}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleClose}
          severity={type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          <span dangerouslySetInnerHTML={{ __html: message }}></span>
        </Alert>
      </Snackbar>
    </div>
  );
}

export default SnackbarPopup;
